import { render, staticRenderFns } from "./account-payments.vue?vue&type=template&id=41156f44&"
import script from "./account-payments.vue?vue&type=script&lang=js&"
export * from "./account-payments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports